import React, { useEffect, useState } from "react";
import "../Stock/Stock.css";
import { ToastContainer, toast } from "react-toastify";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { UilAngleLeft, UilAngleRight } from "@iconscout/react-unicons";
import { userRequest } from "../../RequestMethods";

const MOVEMENT_TYPES = ["", "in", "out", "reserve", "release", "return", "correction"];

const StockMovements = () => {
  const [products, setProducts] = useState([]);
  const [movements, setMovements] = useState([]);
  const [movementsLoading, setMovementsLoading] = useState(true);
  const [movementsPagination, setMovementsPagination] = useState({ page: 1, limit: 25, total: 0, pages: 1 });
  const [filters, setFilters] = useState({ productId: "", type: "" });

  const fetchProducts = async () => {
    try {
      const res = await userRequest.get("products/dropdown", { params: { _: Date.now() } });
      setProducts(res.data.products || []);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Erreur lors du chargement des produits.");
    }
  };

  const fetchMovements = async (page = 1) => {
    try {
      setMovementsLoading(true);
      const params = { page, limit: movementsPagination.limit };
      if (filters.productId) params.productId = filters.productId;
      if (filters.type) params.type = filters.type;

      const res = await userRequest.get("stock/movements", { params });
      setMovements(res.data.movements || []);
      setMovementsPagination(res.data.pagination || { page: 1, limit: 25, total: 0, pages: 1 });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Erreur lors du chargement des mouvements.");
    } finally {
      setMovementsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchMovements(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleApplyFilters = (e) => {
    e.preventDefault();
    fetchMovements(1);
  };

  const handlePrevPage = () => {
    if (movementsPagination.page > 1) fetchMovements(movementsPagination.page - 1);
  };

  const handleNextPage = () => {
    if (movementsPagination.page < movementsPagination.pages) fetchMovements(movementsPagination.page + 1);
  };

  return (
    <div className="Stock">
      <h1>Historique des mouvements</h1>

      <section className="stock-section">
        <form className="stock-filters" onSubmit={handleApplyFilters}>
          <select name="productId" value={filters.productId} onChange={handleFilterChange}>
            <option value="">Tous les produits</option>
            {products.map((product) => (
              <option key={product._id} value={product._id}>{product.title || product._id}</option>
            ))}
          </select>
          <select name="type" value={filters.type} onChange={handleFilterChange}>
            <option value="">Tous les types</option>
            {MOVEMENT_TYPES.filter(Boolean).map((type) => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
          <button type="submit" className="action-icon-btn btn-primary">Filtrer</button>
        </form>

        {movementsLoading ? (
          <div className="loading-container">
            <div className="loading-spinner-custom"></div>
          </div>
        ) : (
          <>
            <TableContainer component={Paper} className="stock-table-container">
              <Table>
                <TableHead>
                  <TableRow className="table-header">
                    <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                    <TableCell>Produit</TableCell>
                    <TableCell>Couleur / Taille</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Quantité</TableCell>
                    <TableCell>Source</TableCell>
                    <TableCell>Par</TableCell>
                    <TableCell>Raison</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {movements.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={8} align="center">Aucun mouvement trouvé.</TableCell>
                    </TableRow>
                  )}
                  {movements.map((movement) => (
                    <TableRow key={movement._id}>
                      <TableCell>{new Date(movement.createdAt).toLocaleString("fr-FR")}</TableCell>
                      <TableCell>{movement.productTitle || "—"}</TableCell>
                      <TableCell>
                        <div className="stock-color-cell">
                          {movement.inventoryItemId?.color && (
                            <span
                              className="color-swatch"
                              style={{ backgroundColor: movement.inventoryItemId.color }}
                            ></span>
                          )}
                          {movement.inventoryItemId?.size || "—"}
                        </div>
                      </TableCell>
                      <TableCell>
                        <span className={`badge movement-${movement.type}`}>{movement.type}</span>
                      </TableCell>
                      <TableCell>{movement.quantity > 0 ? `+${movement.quantity}` : movement.quantity}</TableCell>
                      <TableCell>{movement.sourceType}</TableCell>
                      <TableCell>
                        {movement.performedBy ? `${movement.performedBy.name || ""} ${movement.performedBy.surname || ""}`.trim() : "—"}
                      </TableCell>
                      <TableCell>{movement.reason || "—"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <div className="stock-pagination">
              <button
                className="pagination-btn" onClick={handlePrevPage}
                disabled={movementsPagination.page <= 1}
              >
                <UilAngleLeft /> Précédent
              </button>
              <span>
                Page {movementsPagination.page} / {movementsPagination.pages || 1} ({movementsPagination.total} entrées)
              </span>
              <button
                className="pagination-btn" onClick={handleNextPage}
                disabled={movementsPagination.page >= movementsPagination.pages}
              >
                Suivant <UilAngleRight />
              </button>
            </div>
          </>
        )}
      </section>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default StockMovements;
